/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SquadImport_Output = {
    properties: {
        team: {
            type: 'TeamSmall',
            isRequired: true,
        },
        givenName: {
            type: 'string',
            isRequired: true,
        },
        familyName: {
            type: 'string',
            isRequired: true,
        },
        position: {
            type: 'PlayerPositionEnum',
            isRequired: true,
        },
    },
} as const;
